import request from '@/utils/request'

/**
 * 获取采集订单列表
 * @param {Object} params 查询参数
 * @returns {Promise} 请求Promise
 */
export function listChainInoutOrder(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/chainInoutOrder.listChainInoutOrder',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 新增采集订单
 * @param {Object} data 订单数据
 * @returns {Promise} 请求Promise
 */
export function saveChainInoutOrder(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/chainInoutOrder.saveChainInoutOrder',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 修改采集订单
 * @param {Object} data 订单数据
 * @returns {Promise} 请求Promise
 */
export function updateChainInoutOrder(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/chainInoutOrder.updateChainInoutOrder',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除采集订单
 * @param {Object} data 订单数据
 * @returns {Promise} 请求Promise
 */
export function deleteChainInoutOrder(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/chainInoutOrder.deleteChainInoutOrder',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}